import { ReactNode } from "react";
import { AngularBridge } from "../../other/bridgeSetup/AngularBridge";
import { TabbedRoutesPageWrapper } from "../../uiLibrary/tabbedRoutesPageWrapper/TabbedRoutesPageWrapper";
import { useSingleton } from "../../other/injection";
import { LoggedInUserStore } from "../../other/loggedInUser/LoggedInUserStore";
import { observer } from "mobx-react-lite";

export const ManageInteractionsPageWrapper = observer(
    (props: { children: ReactNode }) => {
        const loggedInUserStore = useSingleton(LoggedInUserStore);

        return (
            <>
                {loggedInUserStore.hasPermission(
                    RedDeer.Contracts.Enums.PermissionType.CanAccessMifid
                ) &&
                    loggedInUserStore.enableInteractionReview && (
                        <AngularBridge
                            name="c-interaction-review"
                            props={{
                                componentKey: "interactionReview",
                                disableDisplay: true
                            }}
                        />
                    )}
                <TabbedRoutesPageWrapper tabsTestId="manageInteractionTabs">
                    {props.children}
                </TabbedRoutesPageWrapper>
            </>
        );
    }
);
